import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Row, Col, Input } from 'components/UI';
import { positiveDoublePattern } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var CommissionAmountsModal = /*#__PURE__*/forwardRef(function (props, reference) {
  var _modalData$data, _modalData$data2, _modalData$data3;

  var onSubmit = props.onSubmit,
      onClose = props.onClose;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      modalData = _useState2[0],
      setModalData = _useState2[1];

  var modalRef = useRef();
  useImperativeHandle(reference, function () {
    return {
      open: function open(data) {
        setModalData(data);
        modalRef.current.open();
      },
      close: function close() {
        modalRef.current.close();
      }
    };
  });

  var formData = _objectSpread({}, modalData === null || modalData === void 0 ? void 0 : modalData.data);

  var handleSubmit = function handleSubmit(_ref) {
    var values = _ref.values;
    return _isFunction(onSubmit) && onSubmit(_objectSpread(_objectSpread({}, modalData), {}, {
      data: values
    }));
  };

  return ___EmotionJSX(Modal, {
    ref: modalRef,
    onClose: onClose
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u0412\u044A\u0432\u0435\u0434\u0438 \u0441\u0443\u043C\u0430"), (modalData === null || modalData === void 0 ? void 0 : modalData.franchisee_name) && ___EmotionJSX("p", {
    className: "mb1"
  }, ___EmotionJSX("strong", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u0440: "), modalData === null || modalData === void 0 ? void 0 : modalData.franchisee_name), ___EmotionJSX("p", {
    className: "mb1"
  }, ___EmotionJSX("strong", null, "\u0421\u0443\u043C\u0430: "), modalData !== null && modalData !== void 0 && modalData.isRequest ? modalData === null || modalData === void 0 ? void 0 : (_modalData$data = modalData.data) === null || _modalData$data === void 0 ? void 0 : _modalData$data.requested_base_amount : modalData === null || modalData === void 0 ? void 0 : (_modalData$data2 = modalData.data) === null || _modalData$data2 === void 0 ? void 0 : _modalData$data2.future_base_amount, " ", modalData === null || modalData === void 0 ? void 0 : (_modalData$data3 = modalData.data) === null || _modalData$data3 === void 0 ? void 0 : _modalData$data3.currency), ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: formData
  }, ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, null, ___EmotionJSX(Input, {
    pattern: positiveDoublePattern,
    number: true,
    formId: modalData !== null && modalData !== void 0 && modalData.isRequest ? 'requested_base_amount' : 'future_base_amount',
    label: "\u0412\u044A\u0432\u0435\u0434\u0438 \u0441\u0443\u043C\u0430",
    validate: function validate(val) {
      return (Number(val) <= 0 || Number(val) > Number(modalData === null || modalData === void 0 ? void 0 : modalData.available_for_report_amount) || !val) && {
        msg: 'Въведете валидно число!'
      };
    }
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref2) {
    var onSubmit = _ref2.onSubmit;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return modalRef.current.close();
      },
      margin: "0 1em 0 0"
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0418\u0437\u043F\u0440\u0430\u0442\u0438"));
  }))));
});
CommissionAmountsModal.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};
export default CommissionAmountsModal;